<template>
<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card-group mb-0">
          <div class="card p-4">
            <div class="card-body">
              <form v-on:submit="validateBeforeSubmit($event,false)" action="#" v-if="showForm">
                <h3>Recuperar a palavra-passe?</h3>
                <p class="text-muted">Introduza o seu email para lhe enviar-mos um email para repor a palavra-passe</p>
                <div class="input-group mb-3">
                  <b-form-input type="email" name="email" v-model="email" placeholder="Email" v-validate="{ required: true, email:true }" :state="validateState('email')"></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('email') }}
                  </b-form-invalid-feedback>
                </div>
                <div class="row">
                  <div class="col-6">
                    <router-link :to="{name: 'login'}">Voltar ao login</router-link>
                  </div>
                  <div class="col-6 text-right">
                    <button :disabled="working" type="submit" class="btn btn-primary px-4">Seguinte</button>
                  </div>

                </div>
              </form>
              <div v-if="!showForm">
                <h2>Recuperar a palavra-passe?</h2>
                <p v-if="emailSent" >Foi-lhe enviado um email para recuperar a palavra-passe<br>
                  <router-link :to="{name: 'login'}">Voltar ao login</router-link>
                </p>
                <p v-if="!emailSent" >Este email não está registado</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      working: false,
      email: '',
      emailSent: false,
      showForm: true
    }
  },
  methods: {
    validateBeforeSubmit(evt) {
      evt.preventDefault()
      this.working = true
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit()
          return
        }
        this.working = false
        this.$toastr('error', 'Tem campos inválidos', 'Erro')
      })
    },
    submit() {
      this.axios.post('auth/sendreset', {email: this.email}).then(response => {
        this.emailSent = true
        this.showForm = false
      }).catch(response => {
        this.$toastr('error', 'Não foi possível enviar email de recuperação', 'Erro')
        this.working = false
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    }
  }
}
</script>



// WEBPACK FOOTER //
// Forgot.vue?736d9f96